import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { courseToAssignFilters } from "../../../../../shared/utils/entitiesFiltersUtils";
import { selectEntitiesByFilters } from "../../../../../shared/store/views/entityView";
import iconsList from "../../../../../shared/components/ui/icons/iconsList";
import Icon from "../../../../../shared/components/ui/icons/Icon";
import pathRouts from "../../../../../shared/enums/pathRoute";
import MobileBanner from "../../../../../shared/components/ui/mobileBanner/MobileBanner";
import PrimaryBtn from "../../../../../shared/components/ui/buttons/PrimaryBtn";
import classes from './AssignPopupHeader.module.css';

const AssignPopupHeader = ({ Btn, onClose }) => {

    const navigate = useNavigate()
    const { texts } = useSelector(state => state.translate);
    const coursesToAssign = useSelector(state => selectEntitiesByFilters(state, courseToAssignFilters));

    const onHendelClick = () => {
        navigate(`/${pathRouts.MYLEARNING}/${pathRouts.ASSIGNSTUDYGTOUP}`);
    }

    return (
        <>
        <MobileBanner text={texts.assignSyudyGroupTextPopupHeaderMobile} className={classes.MobileBanner} />
            {coursesToAssign?.length > 0 &&
                <div className={classes.Container} role="dialog" aria-label={texts?.assignSyudyGroupTextPopup1} >
                    <p className={classes.Title}>{`${texts.thereIs ?? ""} ${coursesToAssign?.length} ${texts?.assignSyudyGroupTextPopupHeader ?? ""}`}</p>
                    <p className={classes.TitleMobile}>{`${texts?.assignSyudyGroupTextPopupHeader ?? ""}`}</p>
                    {Btn && <PrimaryBtn dropClass={classes.Btn} onClick={onHendelClick}>{texts.toAssignStudyGroup}</PrimaryBtn>}
                    {onClose && <Icon name={iconsList.x} size={24} color={'#000000ff'} onClick={onClose}></Icon>}
                </div>
            }
        </>
    )
};
export default AssignPopupHeader;